import React from 'react';
import './Team.css';

function Team() {
  const teamMembers = [
    {
      name: "Arun Agarwal",
      title: "Partner",
      bio: "Arun was the founder and Co-CIO at Altavista, a single-family office investment manager, for over fifteen years. Before founding Altavista, Arun was an Investment Principal at the India office of Q Investments where he focussed on Indian public equities. Prior to that Arun was an investment banker with Merrill Lynch in India where he led the Telecom and Oil & Gas teams. Arun spent seven years at McKinsey primarily serving telecom, oil & gas and manufacturing clients across India, China and the US. Arun's time at McKinsey was in two parts with a year-long gap during which he founded an unsuccessful internet startup. Arun joined McKinsey in 1996 from IIM Calcutta. He has a degree in Computer Science & Engineering from IIT Kharagpur. Arun is a founding partner of YK2 Partners since its inception in 2022.",
      linkedin: "https://www.linkedin.com/in/arun-agarwal-7b27351/"
    },
    {
      name: "Hemant Balyan",
      title: "Partner",
      bio: "Hemant was a Vice President at Altavista, a single-family office investment manager, for about five years. Before Altavista, he worked as Senior Associate at Trifecta Capital, a leading venture debt fund in India. Prior to that, he worked in the CEO's office at Piramal Enterprises, which he joined after IIM Ahmedabad in 2014. Before IIM, he worked at the McKinsey Knowledge Center for about three years and had a brief stint at Clean Max Energy Solutions, a clean energy start-up. He has an engineering degree from IIT Delhi. Hemant is a founding partner of YK2 Partners since its inception in 2022.",
      linkedin: "https://www.linkedin.com/in/hemant-balyan-42767910/"
    },
    {
      name: "Jai Anand",
      title: "Partner",
      bio: "Jai was a Vice President at Altavista, a single-family office investment manager, for over six years. Before Altavista, Jai was a quant strategist at Goldman Sachs in their Investment Banking division for two years. He joined Goldman Sachs in 2014 from IIM Bangalore. During IIM, he completed a semester at NYU Stern School of Business as part of a student exchange program. Prior to IIM, Jai worked as an engineer at NVIDIA. He has an Electrical Engineering degree from IIT Kharagpur. Jai is also a CFA charter holder. Jai is a founding partner of YK2 Partners since its inception in 2022.",
      linkedin: "https://www.linkedin.com/in/jai-anand-1b1099b/"
    },
    {
      name: "Vinod Nair",
      title: "Partner",
      bio: "Vinod was Co-CIO at Altavista, a single-family office investment manager, for over a decade. Before Altavista, he was a senior research analyst and portfolio manager in the London office of Alliance Bernstein in their Value Equities business for eight years. Vinod spent seven years at McKinsey, serving clients in the automotive, industrial and high technology sectors in India, Australia and the US. He joined McKinsey in 1995 from IIM Ahmedabad. Prior to IIM, he worked as an engineer at Larsen & Toubro Ltd in Mumbai. He has a degree in Manufacturing Science and Engineering from IIT Kharagpur. Vinod is a founding partner of YK2 Partners since its inception in 2022.",
      linkedin: "https://www.linkedin.com/in/vinod-nair-95210a2/"
    }
  ];

  return (
    <div className="team-page">
      <section className="team-banner">
        <div className="banner-content">
          <div className="banner-accent-line" aria-hidden="true"></div>
          <div className="banner-text">
            <h1>Meet our Team</h1>
            <p>
              We are a team of four partners who have worked together for a long time and are completely aligned with the goals, 
              guiding principles, and culture of our firm. We have a shared excitement and conviction about the opportunities offered 
              by the Indian public markets, our style of investing, and the kind of firm we want to build.
            </p>
          </div>
        </div>
      </section>

      <section className="team-profiles">
        <div className="profiles-container">
          {teamMembers.map((member, index) => (
            <div key={index} className="profile-card">
              <div className="profile-header">
                <div className="profile-name-title">
                  <h2>{member.name}</h2>
                  <p className="profile-title">{member.title}</p>
                </div>
                <a 
                  href={member.linkedin} 
                  className="linkedin-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${member.name} LinkedIn profile (opens in new tab)`}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="currentColor"/>
                  </svg>
                </a>
              </div>
              <div className="profile-bio">
                <p>{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Team;
